module.exports = __webpack_public_path__ + "static/media/0303.37bb4ee4.png";